import axiosInstance from "@/api/axios-instance";
import {
  ProfessionalStatus,
  ProfessionalStatusChangeReason,
} from "../schema/professional-schema";

export interface ChangeProfessionalStatusInput {
  status: ProfessionalStatus;
  reason: ProfessionalStatusChangeReason;
  note?: string;
}

export interface ProfessionalStatusLog {
  id: string;
  professional_id: string;
  previous_status: ProfessionalStatus | null;
  new_status: ProfessionalStatus;
  reason: ProfessionalStatusChangeReason;
  note: string | null;
  internal_user_id: string | null;
  actor_clerk_id: string | null;
  actor_name: string | null;
  changed_by_name: string | null;
  created_at: string;
}

// The only path that changes a professional's status. The server records the
// change with the reason in the same transaction (RH-506).
export async function changeProfessionalStatus(
  id: string,
  data: ChangeProfessionalStatusInput
): Promise<{ log: ProfessionalStatusLog }> {
  const response = await axiosInstance.patch(`/professional/${id}/status`, {
    status: data.status,
    reason: data.reason,
    ...(data.note?.trim() ? { note: data.note.trim() } : {}),
  });
  return response.data;
}
